import { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageTitle } from "../Store/reducers/Common";
import { useDispatch } from "react-redux";
const PageNotFound = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(setPageTitle(`Page not found`));
	}, [dispatch]);
	return <>
		<div className="main-form-sec error-page">
		  <h1 className="error">404</h1>
		  <div className="page">Ooops!!! The page you are looking for is not found</div>
		  <Link to={'/'} className="btn btn-blue"><i className="fa-solid fa-chevron-left me-2"></i><span>Back to Dashboard</span></Link>
		</div>
	</>
}

export default PageNotFound;